const submitTagLookup = {
  registrar:  'reg1-submit',
  pessoal:    'reg2-submit',
  financeiro: 'reg3-submit',
  loanOffers: 'reg4-submit',
};

export default function trackPageSubmit(path) {
  const tag = submitTagLookup[path];
  if (tag && typeof (satelliteTrack) !== 'undefined') {
    satelliteTrack(tag, 'Unable to track page submit.');
  }
}
